import { types } from "../types/types";
import { fetchConToken } from "../helpers/fetch";
import { startSpinner, finishSpinner } from "./ui/spinner";
import { prepareEmpresaAfiliado } from "../helpers/prepareEmpresaAfiliado";
import { startAlerta } from "./ui/alertas";
import { handleErrorApi } from "../helpers/randoms";

export const empresasAfiliadoTraerStart = () => ({
  type: types.empresasAfiliadoTraerStart,
});

export const empresasAfiliadoLimpiar = () => ({
  type: types.empresasAfiliadoLimpiar,
});

export const empresasAfiliadoTraerError = (error) => ({
  type: types.empresasAfiliadoTraerError,
  payload: error,
});

export const empresasAfiliadoInsertError = (error) => ({
  type: types.empresasAfiliadoInsertError,
  payload: error,
});

export const empresasAfiliadoTraerSuccess = (payload) => {
  return {
    type: types.empresasAfiliadoTraerSuccess,
    payload: payload,
  };
};

const empresasAfiliadoUpdated = (empresaAfiliado) => {
  return {
    type: types.empresasAfiliadoUpdated,
    payload: empresaAfiliado,
  };
}

const empresaAfiliadoDeleteSuccess = (payload) => {
  return {
    type: types.empresasAfiliadoDeleted,
    payload: payload,
  };
};

const empresaAfiliadoInsertSuccess = (payload) => {
  return {
    type: types.empresasAfiliadoInsertSuccess,
    payload: payload,
  };
};

export const empresasAfiliadoStartUpdate = (empresaAfiliado) => {
  return async (dispatch) => {
    try {
      console.log("ENTRE A UPDATEAR");
      const emp = prepareEmpresaAfiliado(empresaAfiliado);
      dispatch(startSpinner());
      let body;
      const response = await fetchConToken(`EmpresasAfiliados/${empresaAfiliado.idEmpresasAfiliados}`, emp, 'PUT');
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          dispatch(startAlerta(`${empresaAfiliado.empresa.denominacion} Actualizada correctamente`, 'success', 'Comando Exitoso'));
          dispatch(empresasAfiliadoUpdated(empresaAfiliado));
        } else {
          dispatch(startAlerta(response, 'error', 'Error'));
          console.log(response);
          throw new Error(response);
        }
      } else {
        body = await response.json();
        handleErrorApi(
          dispatch,
          null,
          "Error al dar de alta período",
          body.errores.mensaje
        );
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(startAlerta(error, 'error', 'Error'));
      console.log('error en update empresa afiliado', error);
    }
  };
};

export const empresaAfiliadoInsertStart = (empresaAfiliado) => {
  return async (dispatch, getState) => {
    try {
      const { afiliado, consultaAfiliado } = getState().afiliacion;
      const { afiliadoEncontrado } = getState().preinscripto;
      let response;
      let empresaAfiMandar;
      let body;

      if (afiliado && afiliadoEncontrado === null) {
        empresaAfiMandar = {
          ...empresaAfiliado,
          idAfiliado: afiliado.id_afiliado === undefined ? consultaAfiliado.id_afiliado : afiliado.id_afiliado,

        };
        dispatch(startSpinner());
        response = await fetchConToken(`EmpresasAfiliados`, empresaAfiMandar,"POST");
      }
      
      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          const emp = await response.json();
          dispatch(empresaAfiliadoInsertSuccess(emp));
        } else {
          throw new Error(response);
        }
      } else {
        body = await response.json();
        handleErrorApi(
          dispatch,
          null,
          "Error al dar de alta período",
          body.errores.mensaje
        );
      }
      dispatch(finishSpinner());
    } catch (error) {
      console.log("error en insert empresa afiliado", error);
    }
  };
};

export const empresaAfiliadoDeleteStart = (empresaAfiliado) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(`EmpresasAfiliados/${empresaAfiliado.idEmpresasAfiliados}`, {}, 'DELETE');

      if (response.ok) {
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          await response.json();
          dispatch(empresaAfiliadoDeleteSuccess(empresaAfiliado.idEmpresasAfiliados));
        } else {
          throw new Error(response);
        }
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      console.log("error en delete empresa afiliado", error);
    }
  };
};

export const fetchEmpresasAfiliado = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(empresasAfiliadoTraerStart());
    const response = await fetchConToken(`EmpresasAfiliados/${idAfiliado}`);
    if (!response.ok) {
      dispatch(empresasAfiliadoTraerError(response.statusText));
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      dispatch(empresasAfiliadoTraerSuccess(lista));
    }
    dispatch(finishSpinner());
  };
};

export const fetchEmpresasAfiliadoxCUILAportes = (cuil) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    dispatch(empresasAfiliadoTraerStart());
    const response = await fetchConToken(`EmpresasAfiliados/TraerPorCUIL/${cuil}`);
    if (!response.ok) {
      dispatch(empresasAfiliadoTraerError(response.statusText));
      throw Error(response.statusText);
    }
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      const lista = await response.json();
      if (lista.length > 0) {
        dispatch(empresasAfiliadoTraerSuccess(lista));
      }
    }
    dispatch(finishSpinner());
  };
};
